import React from 'react';
import { useFloating, autoUpdate, offset, flip, shift } from '@floating-ui/react-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { Check, Star, User } from 'lucide-react';

const EmployeeDropdown = ({ index,
    row,
    isOpen,
    onClose,
    assignedPeopleList,
    employeesfinalList,
    matchedGroup,
    setAssignedPeopleList,
    selectedPrimaryResourceList,
    setSelectedPrimaryResourceList,
    employees,
    setOpenRow,
    openRow,
    onScrollToSelectOption
}) => {
    console.log("selectedPrimaryResourceList", selectedPrimaryResourceList);
    const normalizeService = (value) =>
        (value || "").toString().trim().toLowerCase();

    const getRequestedServices = (typeService) => {
        if (Array.isArray(typeService)) {
            return typeService.map(normalizeService).filter(Boolean);
        }

        const raw = (typeService || "").toString();
        return raw
            .split(/,|&| and /i)
            .map(normalizeService)
            .filter(Boolean);
    };

    const requestedServices = getRequestedServices(row?.TypeService);
    const rowGroupId = String(
        row?.lead?.groupid?._id ||
        row?.lead?.groupid ||
        row?.groupid?._id ||
        row?.groupid ||
        ""
    );
    const filteredEmployees = employeesfinalList.filter(
        (emp) => {
            const employeeGroupId = String(
                emp?.groupId?._id ||
                emp?.groupId?.id ||
                emp?.groupId ||
                ""
            );
            return (
                employeeGroupId === rowGroupId &&
            requestedServices.includes(normalizeService(emp.employeeId?.servicetype)) &&
            !matchedGroup?.ProjectManagerAction?.some(
                (action) =>
                    action.Manager === `${emp.employeeId?.EmpFirstName} ${emp.employeeId?.EmpLastName}`
            )
            );
        }
    );

    const { refs, floatingStyles } = useFloating({
        open: isOpen,
        onOpenChange: onClose,
        whileElementsMounted: autoUpdate,
        placement: 'bottom-start',
        middleware: [offset(5), flip(), shift()],
    });

    return (
        <>
            <div
                ref={refs.setReference}
                className="employeeselectiondropdown dropdown-container w-[80%] rounded-md relative flex justify-center text-xs align-middle items-center border border-gray-300"
            >
                <button
                    onClick={
                        () => {
                            onClose(!isOpen)
                            if (index === 0) {
                                setOpenRow(
                                    index
                                )
                            } else {
                                setOpenRow(
                                    openRow === index ? null : index
                                );
                            }


                        }
                    }
                    className="w-full text-xs px-2 py-2 truncate flex justify-between items-center"
                >
                    {assignedPeopleList[index]?.length > 0
                        ? assignedPeopleList[index].map((item) => item.name).join(", ")
                        : "Resources"}
                </button>
                <ExpandMoreIcon
                    onClick={
                        () => {
                            onClose(!isOpen)
                            if (index === 0) {
                                setOpenRow(
                                    index
                                )
                            } else {
                                setOpenRow(
                                    openRow === index ? null : index
                                );
                            }


                        }
                    }
                    className="ml-1 absolute right-0 cursor-pointer bg-white group-hover:bg-gray-100" />
            </div>

            {isOpen && (
                <div
                    ref={refs.setFloating}
                    style={floatingStyles}
                    className="w-72 rounded-md bg-white border border-gray-300 shadow-lg z-50 narrow-scrollbar"
                >
                    <div className='w-full px-2 py-3 bg-[#e8e8e8] flex text-xs font-normal rounded-t'>
                        <div className='w-[40%] flex gap-1 justify-start align-middle items-center text-start'>
                            <Check size={16} />
                            Click to select
                        </div>
                        <div className='w-[60%] flex justify-start align-middle items-center gap-1 text-start'>
                            <Star size={16} />
                            Click star for primary
                        </div>
                    </div>

                    <div className=" max-h-60 overflow-y-auto rounded-b">
                        {filteredEmployees.length > 0 ? (
                            filteredEmployees
                                .map((emp) => {
                                    const fullName = `${emp.employeeId?.EmpFirstName} ${emp.employeeId?.EmpLastName}`;
                                    const empEmail = emp.employeeId?.EmpEmail;
                                    const empdesignation = `${emp.employeeId?.servicetype} Manager`
                                    const isAssigned = assignedPeopleList[index]?.some(
                                        (item) => item.email === empEmail
                                    );
                                    const isPrimary = selectedPrimaryResourceList[index] === empEmail;

                                    return (
                                        <label
                                            key={emp.employeeId?.id || emp.employeeId?._id}
                                            className="flex justify-between align-middle items-center px-2 py-1 bg-white hover:bg-gray-100 text-xs"
                                        >
                                            <div className='flex gap-1 align-middle justify-start items-center py-2 '>
                                                <input
                                                    title="Select Resources"
                                                    type="checkbox"
                                                    className="mr-2 w-4 h-4"
                                                    value={fullName}
                                                    checked={isAssigned || false}
                                                    onChange={(e) => {
                                                        const selectedValue = {
                                                            name: fullName,
                                                            email: empEmail,
                                                        };
                                                        const isChecked = e.target.checked;
                                                        if (isChecked && typeof onScrollToSelectOption === 'function') {
                                                            onScrollToSelectOption();
                                                        }
                                                        setAssignedPeopleList((prev) => {
                                                            const current = prev[index] || [];
                                                            if (isChecked) {
                                                                const alreadyExists = current.some(
                                                                    (item) => item.email === selectedValue.email
                                                                );
                                                                if (!alreadyExists) {
                                                                    return {
                                                                        ...prev,
                                                                        [index]: [...current, selectedValue],
                                                                    };
                                                                }
                                                            } else {
                                                                if (selectedPrimaryResourceList[index] === empEmail) {
                                                                    setSelectedPrimaryResourceList((prev) => ({
                                                                        ...prev,
                                                                        [index]: null,
                                                                    }));
                                                                }
                                                                return {
                                                                    ...prev,
                                                                    [index]: current.filter(
                                                                        (item) => item.email !== selectedValue.email
                                                                    ),
                                                                };
                                                            }
                                                            return prev;
                                                        });
                                                    }}

                                                />
                                                <div className='flex gap-1 align-middle '>
                                                    <div className='flex align-middle items-center'>
                                                        <div className='p-2 rounded-full bg-[#d8e6fd]'>
                                                            <User size={16} color="#050505" />
                                                        </div>
                                                    </div>
                                                    <div className='flex flex-col text-start'>
                                                        <p className='font-semibold text-sm capitalize text-black'>{fullName} </p>
                                                        <p className='font-normal text-[#65758b]'>{empdesignation} </p>
                                                    </div>

                                                </div>
                                            </div>

                                            <button
                                                title="Select Primary Resource"
                                                className="primaryselector focus:outline-none p-1"
                                                disabled={!isAssigned}
                                                onClick={() => {
                                                    if (isAssigned) {
                                                        setSelectedPrimaryResourceList((prev) => ({
                                                            ...prev,
                                                            [index]: prev[index] === empEmail ? null : empEmail,
                                                        }));
                                                    }
                                                }}
                                            >
                                                <Star
                                                    size={20}
                                                    fill={isPrimary ? "#FFD700" : "none"}
                                                    stroke={isPrimary ? "#FFD700" : "#000000"}
                                                    className={`transition-colors ${!isAssigned ? 'opacity-30' : 'cursor-pointer hover:stroke-yellow-500'}`}
                                                />
                                            </button>
                                            {/* <input
                                            title="Select Primary Resource"
                                            className="primaryselector"
                                            type="checkbox"
                                            checked={selectedPrimaryResourceList[index] === empEmail}
                                            disabled={!isAssigned}
                                            onChange={() => {
                                                if (isAssigned) {
                                                    setSelectedPrimaryResourceList((prev) => ({
                                                        ...prev,
                                                        [index]: prev[index] === empEmail ? null : empEmail,
                                                    }));
                                                }
                                            }}
                                        /> */}
                                        </label>
                                    );
                                })
                        ) : (
                            <div className="px-2 py-1 text-gray-500">No matching resources found.</div>
                        )}
                    </div>

                    {selectedPrimaryResourceList[index] && (
                        <div className='p-2 selectedprimary flex justify-start border-t border-gray-200'>
                            {(() => {
                                const primaryEmail = selectedPrimaryResourceList[index];
                                if (!primaryEmail) {
                                    return <div className='text-sm text-gray-500 italic'>No primary manager selected</div>;
                                }

                                const primaryEmp = employeesfinalList.find(
                                    emp => emp.employeeId?.EmpEmail === primaryEmail
                                );

                                if (!primaryEmp) {
                                    return <div className='text-sm text-red-500 italic'>Primary manager not found</div>;
                                }

                                const fullName = `${primaryEmp.employeeId?.EmpFirstName} ${primaryEmp.employeeId?.EmpLastName}`;

                                return (
                                    <div className='inline-flex align-middle items-center gap-1 py-1 px-2 rounded-full bg-[#3c83f6] text-white'>
                                        <Star
                                            size={10}
                                            fill={"#ffffff"}
                                            stroke={"#ffffff"}
                                        />
                                        {fullName}
                                    </div>
                                );
                            })()}
                        </div>
                    )}

                </div>
            )}
        </>)
}

export default EmployeeDropdown